import React from 'react'
import RoutesComponent from '../../routes/Routes'
import { useVersionCheck } from '../../Hooks/versionCheckHook'

function App() {
	useVersionCheck()

	return (
		<div className="App">
			<RoutesComponent />
		</div>
	)
}

export default App
